import LegacyBookmarkModal from './LegacyBookmarkModal';

export * from './LegacyBookmarkModal';

export default LegacyBookmarkModal;
